import './header.css'
import Logo from '../../../images/header-logo-captify.svg'
import { Image } from 'react-bootstrap'
const Header = () => {
  return (
    <div className='headerWrapper position-sticky top-0'>
        <a href="https://captify.glass" target='_blank' className='cursor-pointer'><Image src={Logo} height={30}/></a>
    </div>
  )
}

export default Header